import { Component, Input } from '@angular/core';
import { FormControl } from '@angular/forms';
import { PasswordForm, PasswordFormFields } from 'src/app/auth/auth-form.inteface';
import { FormGroupControls } from 'src/app/interfaces/form-and-field.interface';
import { EyePasswordTextings } from 'src/app/interfaces/views.interface';

@Component({
  selector: 'app-eye-password',
  templateUrl: './eye-password.component.html',
  styleUrls: ['./eye-password.component.scss'],
})
export class EyePasswordComponent {
  @Input({ required: false }) public controlName: PasswordFormFields = 'password';
  @Input({ required: true }) public dataTestId = 'password';
  @Input({ required: false }) public showValidMark = false;
  @Input({ required: true }) public errorTexting: EyePasswordTextings = {
    dataTestId: 'password-error',
    text: 'INCORRECT_PASSWORD_INPUT_ERROR',
  };
  @Input({ required: false }) public validTexting: EyePasswordTextings;
  @Input({ required: false }) public instructionTexting: EyePasswordTextings;
  @Input({ required: false }) public id = 'password';
  @Input({ required: false }) public labelDataTestId = 'password-label';
  @Input({ required: false }) public iconDataTestId = 'password-icon';
  @Input({ required: false }) public placeholder = 'LOGIN_FORM_PASSWORD_INPUT_PLACEHOLDER';
  @Input({ required: false }) public inputLabel = 'LOGIN_FORM_PASSWORD_LABEL';
  @Input({ required: true }) public form: FormGroupControls<PasswordForm>;
  @Input({ required: true }) public invalid = false;
  @Input({ required: false }) public formValid = true;

  public showPassword = false;

  public togglePasswordFieldType(): void {
    this.showPassword = !this.showPassword;
  }

  public onBlur(): void {
    const control: FormControl<string> | undefined = this.form.controls[this.controlName];

    if (control) {
      control.setValue(control.value.trim());
    }
  }
}
